import React, { useEffect, useState, useContext } from "react";
import { useTheme } from "@emotion/react";
import { CcRootContext } from "../conversionCenterRoot";
import CcHeaderVideo from "./ccHeaderVideo";
import TagPlaceholder from "./ccTagPlaceholder";
import eventBus from "../../../helpers/eventBus";

const CcHeader = ({ details, showDetails = true, video, defaultScreen }) => {
  const theme = useTheme();
  const ctx = useContext(CcRootContext);
  const [videoData, setVideoData] = useState(null);
  const [error, setError] = useState(null);
  const [hiddenOnMobile, setHiddenOnMobile] = useState(video.hideOnMobile && ctx.isMobile);
  const [loaded, setLoaded] = useState(false);

  const headingStyle = {
    fontFamily: theme.font.primary,
    fontSize: theme.f_sizes.xl,
    textAlign: "center",
    marginBottom: 5,
    wordBreak: "break-word"
  };

  const headingDescriptionStyle = {
    color: theme.colors.black,
    textAlign: "center",
    opacity: .6,
    marginTop: 0,
    marginBottom: theme.f_sizes.base,
    wordBreak: "break-word"
  };

  useEffect(() => {
    const uuid = ctx.draftId;
    if (video?.videoUrl?.length === 0 && video?.videoTag?.length === 0) return;
    const isUrl = video?.videoUrl.includes("vimeo.com/")
    if (!uuid) return;
    const apiUrl = isUrl ? `video/${video.videoUrl.split("/").pop()}` : `tag/${video.videoTag}/${uuid}`;

    fetch(`/api/public/vimeo/${apiUrl}`)
      .then((resp) => {
        if (resp.ok) return resp.json();
        const tag = video.videoTag;
        setLoaded(false);
        eventBus.publish("header:video:tag", { tag: tag, msg: `No video tagged with ${tag} found in subscriber showcase. When ${tag} will be added to any video in subscriber showcase it will show in conversion center without any updates`});
      })
      .then((data) => {
        if (!data) return;
        setVideoData(data.video.table);
        setLoaded(true);
      })
      .catch((error) => {
        console.error(error);
        setError(`Failed to load video`);
        setLoaded(true);
      })
  }, [ctx.draftId, details?.title, video.videoTag, video.videoUrl]);

  useEffect(() => {
    setHiddenOnMobile(video.hideOnMobile && ctx.isMobile);
  }, [ctx.isMobile, video.hideOnMobile]);

  return(
    <>
      {video.videoActive && (video?.videoUrl || video?.videoTag) && !hiddenOnMobile  && (
        <>
          {loaded && (video.videoUrl.includes("vimeo.com") || video?.videoTag.length > 0) && !video.errors?.videoUrl && (
            <>
              <CcHeaderVideo 
                src={videoData?.video?.link}
                type={videoData?.video?.type}
                poster={videoData?.preview_image_url || ""}
                name={videoData?.name}
                resizeOnOrientationChange
              />
              {error && <p>{error}</p>}
            </>
          )}
          {defaultScreen?.template && !video.videoUrl.includes("vimeo.com") && (
            <TagPlaceholder tag={video.videoUrl} />
          )}
        </>
      )}
      <h1 css={headingStyle}>{details?.title || "Welcome to our Education Center"}</h1>
      {showDetails && <p css={headingDescriptionStyle}>{details?.subtitle || "click to explore"}</p>}
    </>
  );
};

export default CcHeader;
